export default {"src":"/_next/static/media/calendar-right-arrow.89815e18.svg","height":14,"width":8,"blurWidth":0,"blurHeight":0};